// third party imports
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// internal rebet imports
import "./stylesUserManagerHeader.css";
import { USER_HEADER_TABS } from "../../../../utils/Constants";
import { ArrowLeftOutlined } from "@ant-design/icons";

// component imports

// asset imports

const UserManagerHeader = ({ selectedTab, setSelectedTab }) => {
  // non-state variables
  const navigate = useNavigate();

  // state variables

  // use effects'

  // api functions

  // helper functions
  const handleSetSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  const handleBackPressed = () => {
    navigate(-1);
  };

  return (
    <div className="user-manager-header-container">
      <div className="back-button-container" onClick={handleBackPressed}>
        <ArrowLeftOutlined className="back-arrow" size={16} />
        <p className="back-text">Back To Users</p>
      </div>
      <div className="user-manager-header">
        <button
          className={
            selectedTab === USER_HEADER_TABS?.OVERVIEW
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.OVERVIEW)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.OVERVIEW
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Overview
          </p>
        </button>

        <button
          className={
            selectedTab === USER_HEADER_TABS?.TRANSACTIONS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.TRANSACTIONS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.TRANSACTIONS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Transactions
          </p>
        </button>

        <button
          className={
            selectedTab === USER_HEADER_TABS?.BETS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.BETS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.BETS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Sports Bets
          </p>
        </button>

        <button
          className={
            selectedTab === USER_HEADER_TABS?.CASINO_BETS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.CASINO_BETS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.CASINO_BETS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Casino Bets
          </p>
        </button>

         <button
          className={
            selectedTab === USER_HEADER_TABS?.POKER_BETS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.POKER_BETS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.POKER_BETS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Poker
          </p>
        </button> 

        <button
          className={
            selectedTab === USER_HEADER_TABS?.GAME_PASS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.GAME_PASS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.GAME_PASS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Game Pass
          </p>
        </button> 

        <button
          className={
            selectedTab === USER_HEADER_TABS?.ALT_ODS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.ALT_ODS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.ALT_ODS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            Alt-Odds
          </p>
        </button>
      </div>
    </div>
  );
};

export default UserManagerHeader;
